import React from 'react'
import { Api } from '../../redux/api/BaseApi';
import { ITicket } from '../../types/Ticket/ITicket';

export default function TimelineImage(ticket: ITicket) {
  //const { ticket } = useReduxSelector(state => state.newTicket);

  const { data: imageData } = Api.useGetTimelineImageQuery({ projectId: ticket.Project_Id, priorityId: ticket.Priority_Id, slaId: ticket.SLA_Id });
  const { data: ticketImageData } = Api.useGetTicketTimelineImageQuery(ticket.ID, { skip: !ticket.ID });

  return (
    (ticket?.ID ?
      <img alt='timeline' src={ticketImageData}></img>
      : <img alt='timeline' src={imageData}></img>
    ))
}
